module.exports = __webpack_public_path__ + "static/27-8e38fedad35593ef9f8b26574c8ad6f8.png";